import { createResource, postgRESTApiUrl } from "./api";

/**
 * Batched, per-page engagement for feed items (and comment likes). One call per
 * content_type; the RPC bounds itself to the first 50 ids (feed page is 30).
 *
 * @param {string} contentType - e.g. "Enrich::PublicPitch" or "Interact::Comment"
 * @param {Array<string|number>} contentIds
 * @returns {Promise<{data: Array} | {error: Object}>}
 *   rows: { content_id, like_count, comment_count, liked_by_viewer, top_likers }
 */
const getFeedEngagement = async (contentType, contentIds) => {
  const body = {
    p_content_type: contentType,
    p_content_ids: (contentIds || []).map(String),
  };
  const url = `${postgRESTApiUrl()}/rest/v1/rpc/get_feed_engagement`;
  return createResource(url, body);
};

export default { getFeedEngagement };
